import { MapContext } from 'components/Mapbox/Mapbox'
import mapboxgl from 'mapbox-gl'
import { useContext, useEffect } from 'react'
import styled from 'styled-components'

const HelpToggleDefaults: {
  labelOn: string
  labelOff: string
} = {
  labelOn: '?',
  labelOff: '?',
}

export const HelpToggle = ({
  // viewToReturnToOnDeactivation,
  // returnToViewAtActivation = false,
  isOutside = false,
}: {
  // viewToReturnToOnDeactivation?: mapboxgl.CameraOptions | undefined
  // returnToViewAtActivation?: boolean
  isOutside?: boolean
}) => {
  var {
    map,
    helpVisible,
    setShowHelp,
    setIsInteractive,
    viewToReturnTo,
    isMobile,
  } = useContext(MapContext)

  useEffect(() => {
    if (!map) return

    if (!helpVisible) {
    //   if (viewToReturnToOnDeactivation) {
    //     map.flyTo(viewToReturnToOnDeactivation)
    //   } else if (returnToViewAtActivation && viewToReturnTo) {
    //     map.flyTo(viewToReturnTo)
    //   }

    //   map.dragPan.disable()
    //   map.scrollZoom.disable()
    //   map.touchPitch.disable()
    //   map.dragRotate.disable()
    //   map.doubleClickZoom.disable()
    //   map.keyboard.disable()
    //   map.boxZoom.disable()
    //   map.touchZoomRotate.disableRotation()
    // } else {
    //   if (returnToViewAtActivation && setViewToReturnTo) {
    //     setViewToReturnTo({
    //       center: map.getCenter(),
    //       zoom: map.getZoom(),
    //       bearing: map.getBearing(),
    //       pitch: map.getPitch(),
    //     })
    //   }

    //   map.dragPan.enable()
    //   map.scrollZoom.enable()
    //   map.touchPitch.enable()
    //   map.dragRotate.enable()
    //   map.doubleClickZoom.enable()
    //   map.keyboard.enable()
    //   map.boxZoom.enable()
    //   map.touchZoomRotate.enableRotation()
    }
  }, [helpVisible, map])

  return (
    <InteractiveToggleRoot
      isOutside={isOutside}
      helpVisible={!!helpVisible}
      onClick={() => {
        setShowHelp && setShowHelp(!helpVisible)
      }}
      style={{
        left: isMobile ? 'calc(50% - 20px)' : '50%',
      }}
    >
      {helpVisible
        ? HelpToggleDefaults.labelOff
        : HelpToggleDefaults.labelOn}
    </InteractiveToggleRoot>
  )
}

const InteractiveToggleRoot = styled.button<{
  helpVisible: boolean
  isOutside: boolean
}>`
  /* position: ${(props) => (props.isOutside ? '' : 'absolute')};
  bottom: -1px;
  right: 0; */
  /* transform: ${(props) => (props.isOutside ? '' : 'translateX(-50%)')}; */
  border: 0;
  font-size: 15px;
  color: ${(props) =>
    props.helpVisible ? 'var(--red-main)' : 'var(--brandblue-main)'};
  /* color: #fff; */
  width: 60px;
  /* background-color: rgba(32, 35, 70, 0.2); */
  background-color: var(--blue-bright-3);
  /* background-color: transparent; */
  /* border: 1px solid #fff; */
  background-color: var(--site-background);

  padding: 18px 20px 15px 20px;
  border-radius: 2px;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  @media screen and (max-width: 711px) {
    font-size: 13px;
    padding: 0px;   width: 50px;

  }
  @media screen and (min-width: 712px) {
    &:hover {
      cursor: pointer;
      background-color: var(--red-bright-1);
    }
  }
`
